import React, { memo, useState } from 'react';
import { string, func, bool } from 'prop-types';

const ToggleSwitch = ({ label, onChange, value, className, ...rest }) => {
  const [isActive, setIsActive] = useState(value);
  const onClick = () => {
    setIsActive(!isActive);
    if (onChange) {
      onChange();
    }
  };

  return (
    <div className={`flex justify-start items-center ${className}`}>
      <input
        type="checkbox"
        className="opacity-0 w-0 h-0"
        checked={isActive}
        readOnly
        {...rest}
      />
      <button
        className={`btn w-14 h-8 flex items-center border rounded-full py-1 px-0 duration-500 ease-in-out ${
          isActive
            ? 'bg-brand-primary border-brand-primary'
            : 'bg-white border-gray-200'
        }`}
        onClick={onClick}
        data-testid="toggle-switch"
      >
        <div
          className={`bg-white border-gray-100 w-7 h-7 rounded-full shadow-md transform duration-500 ease-in-out ${
            isActive ? 'translate-x-6' : 'translate-x-0'
          }`}
        />
      </button>
      {!!label && <h2 className="text-gray-400 text-sm ml-2">{label}</h2>}
    </div>
  );
};

ToggleSwitch.propTypes = {
  label: string,
  onChange: func,
  value: bool.isRequired,
  className: string,
  name: string,
};
ToggleSwitch.defaultProps = {
  label: 'LIVE',
  className: null,
  name: 'switch',
};

export default memo(ToggleSwitch);
